import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../lib/LanguageContext';
export function TheNeed() {
  const {
    t,
    tArray
  } = useLanguage();
  const stats = tArray<{
    number: string;
    label: string;
  }>('theNeed.stats');
  return <section className="py-24 md:py-32 bg-ivory relative" id="vision" data-id="element-160">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center max-w-3xl mx-auto mb-20" data-id="element-162">
          <h2 className="text-3xl md:text-5xl font-heading text-navy mb-6" data-id="element-163">
            {t('theNeed.title1')}
            <br data-id="element-164" />
            <span className="text-gold italic" data-id="element-165">{t('theNeed.title2')}</span>
          </h2>
          <p className="text-navy/70 text-lg leading-relaxed" data-id="element-166">
            {t('theNeed.description')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-167">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.8,
          delay: index * 0.2
        }} className="bg-marble p-10 rounded-sm border border-gold/10 text-center flex flex-col justify-center min-h-[240px] shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_8px_30px_rgb(212,168,83,0.1)] transition-shadow duration-500" data-id="element-168">
              <div className="text-5xl md:text-6xl font-heading text-saffron mb-4" data-id="element-169">
                {stat.number}
              </div>
              <div className="text-navy/80 uppercase tracking-widest text-sm font-medium" data-id="element-170">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}